import { Directive, Input } from '@angular/core';
import { MediaAlias } from '~shared/models/media.model';
import { AbstractVisibilityClassDirective } from '../classes/visibility-directive.class';

@Directive({
  selector: '[appHideFor]',
})
export class HideForDirective extends AbstractVisibilityClassDirective {
  @Input('appHideFor') targetMediaAlias: MediaAlias;

  protected onMediaChange(isMediaAliasActive: boolean): void {
    if (isMediaAliasActive) {
      this.hideTemplate();
    } else {
      this.showTemplate();
    }
  }
}
